import {
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  ViewChild,
  ElementRef,
  Input,
  DestroyRef,
  inject,
  signal,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
//import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatSort } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router, RouterLinkWithHref } from "@angular/router";
import {
  MatDialogModule,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MsalService } from "@azure/msal-angular";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { MatSnackBar } from "@angular/material/snack-bar";

// Services
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { UpdateParameterService } from "../../../data/record/update-parameter.service";
import { GetParameterService } from "../../../data/record/get-parameter.service";

import dayjs from "dayjs";

// For Dialog view
import {
  UserDataTemplateDetailsComponent,
  UserDataTemplateData,
  getPreview,
} from "../user-data-template-details/user-data-template-details.component";
import { template } from "@angular-devkit/schematics";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { TableSkeletonComponent } from "../../../shared/skeleton";
import { USER_DATA_TEMPLATE_LIST_I18N } from "./user-data-template-list.i18n";

@Component({
  selector: "app-user-data-template-list",
  templateUrl: "./user-data-template-list.component.html",
  styleUrls: ["./user-data-template-list.component.scss"],
  imports: [...SHARED_IMPORTS, TableSkeletonComponent, PageHeaderComponent],
})
export class UserDataTemplateListComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = USER_DATA_TEMPLATE_LIST_I18N;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;
  @ViewChild("searchInput") searchInput: ElementRef<HTMLInputElement>;

  loginUserId = "";
  filter = ""; //table filtering
  readonly searchExpanded = signal(false);
  isLoading = signal(true);

  public parameterName = "userDataTemplates";

  userDataTemplates: UserDataTemplateData[] = [];
  displayedColumns = ["name", "preview"];

  accountStatus: { [key: string]: string } = {
    OPEN: USER_DATA_TEMPLATE_LIST_I18N.status.active,
    CLOSE: USER_DATA_TEMPLATE_LIST_I18N.status.inactive,
  };

  //dialog with path param
  private dialogRef: MatDialogRef<any, any>;
  private routerUrl: string;

  dataSource: MatTableDataSource<UserDataTemplateData>;

  constructor(
    public storeUser: StoreUserService,
    private route: ActivatedRoute,
    private router: Router,
    private msalService: MsalService,
    public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    private common: DatabaseCacheService,
    private updateParameterService: UpdateParameterService,
    private getParameterService: GetParameterService,
    public snackBar: MatSnackBar,
  ) {
    let user = this.msalService.instance.getActiveAccount();
    this.loginUserId = user.idTokenClaims["sub"];

    // カスタムSVG iconの呼び出し
    this.iconRegistry.addSvgIcon(
      "icon_staff", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_staff.svg",
      ), //必ずサニタイザーを利用して取得する。
    );

    this.iconRegistry.addSvgIcon(
      "icon_setting", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_setting.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-close", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-close.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-open", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-open.svg",
      ),
    );
  }

  ngOnInit() {
    //Admin の一覧で表示を制御する

    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.listUserDataTemplates();
      });

    this.common.parametersUpdated
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((noData) => {});
  }

  ngAfterViewInit() {}

  applyFilter(event?: Event) {
    if (event) {
      this.filter = (event.target as HTMLInputElement).value;
    }
    const filterValue = this.filter.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  // M3 Expandable Search methods
  expandSearch(): void {
    this.searchExpanded.set(true);
    setTimeout(() => {
      this.searchInput?.nativeElement?.focus();
    }, 50);
  }

  collapseSearch(): void {
    if (!this.filter.trim()) {
      this.searchExpanded.set(false);
    }
  }

  onSearchBlur(): void {
    this.collapseSearch();
  }

  clearSearch(event: Event): void {
    event.stopPropagation();
    this.filter = "";
    this.applyFilter();
  }

  openCreateUserDataTemplatepDialog() {
    this.opeUserDataTemplateDetailsDialog(null);
  }

  opeUserDataTemplateDetailsDialog(userDataTemplateData): void {

    const dialogRef = this.dialog.open(UserDataTemplateDetailsComponent, {
      width: "740px",
      disableClose: false,

      data: {
        title: this.i18n.dialog.confirmTitle,
        message: this.i18n.dialog.confirmMessage,
        userDataTemplateData: userDataTemplateData,
      },
    });
    dialogRef
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        if (result == null) {
          return;
        }

        let updatedUserTemplateData = result.updatedData;
        let index = -1;

        if (updatedUserTemplateData.id != null) {
          index = this.userDataTemplates.findIndex(
            (item) => item.id === updatedUserTemplateData.id,
          );
        }

        if (index == -1) {
          let maxId = this.userDataTemplates.reduce(
            (max, item) => (item.id > max ? item.id : max),
            0,
          );
          updatedUserTemplateData.id = maxId + 1;
          this.userDataTemplates.push(updatedUserTemplateData);
        } else {
          this.userDataTemplates[index] = updatedUserTemplateData;
        }

        try {
          this.updateParameterService
            .updateParameter(this.parameterName, this.userDataTemplates)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((res) => {
              let snack = this.snackBar.open(
                this.i18n.message.updateSuccess,
                this.i18n.button.close,
                {
                  duration: 30000,
                },
              );
              snack
                .afterDismissed()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                });
            });
        } catch (e) {
          let snack = this.snackBar.open(
            this.i18n.message.updateError,
            this.i18n.button.close,
            {
              duration: 30000,
            },
          );
          snack
            .afterDismissed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
            });
        }

        this.dataSource = new MatTableDataSource(this.userDataTemplates);
      });
  }

  refreshData(): void {
    this.listUserDataTemplates();
  }

  listUserDataTemplates() {
    this.isLoading.set(true);

    this.getParameterService
      .getParameter(this.parameterName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (res) => {
          this.userDataTemplates = [];
          let items = (res as any).parameterValue;
          if (items == null) {
            items = [];
          }
          for (let i = 0; i < items.length; i++) {
            let item = items[i];

            let template: UserDataTemplateData = {
              id: item.id,
              name: item.name,
              template: item.template,
              preview: getPreview(item.template).join(", "),
            };

            this.userDataTemplates.push(template);
          }

          this.dataSource = new MatTableDataSource(this.userDataTemplates);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.isLoading.set(false);
        },
        (error) => {
          this.isLoading.set(false);
        },
      );
  }
}
